import { HEADER_HEIGHT, SECOND_HEADER_HEIGHT } from "@/constants/components";

import {
  colors,
  HStack,
  TabBar,
  GoiLogo,
  Spacing,
  GLOBAL_MAX_WIDTH,
  customEvent,
  EventTriggerAndTargetType,
  Hamburger,
  useResponsive,
  VStack,
  responsive,
  call,
  GOI_PLATFORM_URL,
  getPrimeUrl,
} from "goi_common";
import { useRouter } from "next/router";
// import { useRecoilValue } from "recoil";
// import { isLoggedInState } from "@/atoms/accountState";

import { useEffect, useMemo, useRef, useState } from "react";

import { Box } from "@chakra-ui/react";

import Link from "next/link";

import { useQuery } from "react-query";

import { Axios } from "@/utils/axios";
import HeaderButton from "./HeaderButton";
import { sessionStorage, storageKeys } from "@/utils/storage";
import { parseToPrimeUrl } from "@/utils/parseToPrimeUrl";

export function Header({ onOpen }: { onOpen: () => void }) {
  const router = useRouter();
  const handleHamburgerClick = () => {
    customEvent({
      newGtm: {
        path: "gnb",
        trigger_and_target: "hamburger",
      },
    });
    onOpen();
  };

  const { isBiggerThanLg } = useResponsive();

  const isBasicLiv =
    sessionStorage.get(storageKeys.productGroup) === "basicliv";
  const isBasicLivProcess = router.route.includes("basic-liv") || isBasicLiv;

  const isSelfFuneral = router.route.includes("self-funeral");
  const isOrganizationFuneral = router.route.includes("organization-funeral");

  const isBenefitTypeOverseas =
    sessionStorage.get(storageKeys.benefitType) === "overseas";
  const isOverseas = router.route.includes("overseas") || isBenefitTypeOverseas;

  const isRegistrationRoute = router.route.includes("registration");

  const isEvent25C = router.route.includes("25-c");

  const isHeaderContentHiddenRoute =
    isRegistrationRoute ||
    router.route.includes("prime-request") ||
    router.route.includes("calculator") ||
    router.route.includes("comparison") ||
    router.route.includes("signed-sangjo") ||
    isEvent25C ||
    isBasicLivProcess ||
    isSelfFuneral ||
    isOrganizationFuneral ||
    isOverseas;

  const isProductHeaderRoute =
    router.pathname === "/" || router.pathname.includes("faq");

  return (
    <header>
      <div
        // css={{
        //   position: "fixed",
        //   width: "100%",
        //   height: `${HEADER_HEIGHT}px`,
        //   top: "0",
        //   zIndex: 1000,
        //   backgroundColor: colors.white,
        //   borderBottom: `1px solid ${colors.gray100}`,
        //   transition: "none",
        //   userSelect: "none",
        // }}

        css={responsive({
          position: "fixed",
          width: "100%",
          height: `${HEADER_HEIGHT}px`,
          top: "0",
          zIndex: 1000,
          backgroundColor: colors.white,
          // borderBottom: {
          //   base: "none",
          //   lg: `1px solid ${colors.gray100}`,
          // },
          transition: "none",
          userSelect: "none",
        })}
      >
        <VStack
          margin="0 auto"
          css={responsive({
            width: {
              base: "100%",
              lg: `${GLOBAL_MAX_WIDTH}px`,
            },
          })}
        >
          <HStack height={HEADER_HEIGHT}>
            <HStack
              padding="13px 16px 13px 20px"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
            >
              <Link
                id="goi-logo"
                href={
                  isHeaderContentHiddenRoute
                    ? isBasicLivProcess
                      ? "/basic-liv/"
                      : isSelfFuneral
                      ? "/self-funeral/"
                      : isOrganizationFuneral
                      ? "/organization-funeral/"
                      : isOverseas
                      ? "/overseas/"
                      : isEvent25C
                      ? "/25-c/"
                      : "/"
                    : String(GOI_PLATFORM_URL)
                }
                onClick={() => {
                  customEvent({
                    newGtm: {
                      path: "gnb",
                      trigger_and_target: "logo-uv_home",
                    },
                  });
                }}
              >
                <GoiLogo color={colors.goiBlack} size={30} />
              </Link>
              {isRegistrationRoute && (
                <HeaderRegistrationButton
                  isHomeViewportTop={false}
                  homePath="/"
                />
              )}

              {!isHeaderContentHiddenRoute && (
                <HStack
                  alignItems="center"
                  style={{
                    background: "white",
                  }}
                >
                  <div
                    css={responsive({
                      display: {
                        lg: "block",
                        base: "none",
                      },
                    })}
                  >
                    <HeaderTabBar />
                  </div>

                  <Spacing orientation="horizontal" gap={36} />
                  <HeaderButtons isHomeViewportTop={false} homePath="/" />

                  <Spacing orientation="horizontal" gap={16} />
                  <Box position="relative">
                    <button
                      onClick={handleHamburgerClick}
                      css={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Hamburger color={colors.gray900} size={24} />
                    </button>
                    {/* <Box
                    position="absolute"
                    className="white"
                    width="12px"
                    height="12px"
                    borderRadius="50%"
                    background="red"
                    fontSize="8px"
                    textAlign="center"
                    verticalAlign="middle"
                    lineHeight="12px"
                    top="-5px"
                    right="-10px"
                  >
                    N
                  </Box> */}
                  </Box>
                </HStack>
              )}
            </HStack>
          </HStack>

          {!isHeaderContentHiddenRoute && (
            <div
              css={responsive({
                background: "white",
                display: {
                  lg: "none",
                  base: "block",
                },
                borderBottom: {
                  lg: "none",
                  base: `1px solid ${colors.gray100}`,
                },
              })}
            >
              <HeaderTabBar />
            </div>
          )}
        </VStack>
      </div>
      <Spacing
        gap={
          isHeaderContentHiddenRoute
            ? HEADER_HEIGHT
            : isBiggerThanLg
            ? HEADER_HEIGHT + SECOND_HEADER_HEIGHT
            : HEADER_HEIGHT + 60
        }
      />

      {isProductHeaderRoute && <HeaderProductTabBar />}
    </header>
  );
}

export const MENU_DATA = {
  견적: {
    to: "/match/request/",
    activePath: "견적",
  },
  상품안내: {
    to: "/product",
    activePath: "상품",
  },
  가이드북: {
    to: "/guidebook/",
    activePath: "가이드북",
  },
  후기: {
    to: "/review/",
    activePath: "후기",
  },
} as const;

const MENUS: {
  text: string;
  to: string;
  eventDetails: EventTriggerAndTargetType["gnb"][];
  activePath: string;
}[] = [
  // {
  //   text: "홈",
  //   to: "/",
  //   eventDetails: ["nav-uv_home"],
  // },
  {
    text: "장례견적",
    to: MENU_DATA["견적"].to,
    eventDetails: ["nav-uv_match_request"],
    activePath: MENU_DATA["견적"].activePath,
  },
  {
    text: "상품안내",
    to: MENU_DATA["상품안내"].to,
    eventDetails: ["nav-uv_prime"],
    activePath: MENU_DATA["상품안내"].activePath,
  },
  {
    text: "장례절차",
    to: MENU_DATA["가이드북"].to,
    eventDetails: ["nav-uv_guidebook"],
    activePath: MENU_DATA["가이드북"].activePath,
  },
  {
    text: "고객후기",
    to: MENU_DATA["후기"].to,
    eventDetails: ["review-uv_review"],
    activePath: MENU_DATA["후기"].activePath,
  },

  // {
  //   text: "이벤트",
  //   to: "https://prime.goifuneral.co.kr/promotion?utm_campaign=platform",
  //   eventDetails: ["nav-uv_prime_event"],
  // },
  // {
  //   text: "24시간 전화",
  //   to: "tel:1666-9784",
  //   eventDetails: ["call-opn_call_mdl"],
  // },
];

function HeaderTabBar() {
  // const { activePath } = useActivePathCheck();
  const { isBiggerThanLg } = useResponsive();
  const { data, isSuccess } = useQuery(["funeral_reviews"], () => {
    return Axios.get("/sangjo_reviews/");
  });

  const router = useRouter();
  const reviewCount = isSuccess ? data?.data?.count || 853 : 0;

  const { isHide } = useHandleHeaderServiceTabBar({
    firstOffset: 0,
  });

  const isHeaderTabBarHidden = useMemo(() => {
    return isBiggerThanLg ? false : isHide;
  }, [isHide, isBiggerThanLg, router.asPath]);

  return isHeaderTabBarHidden ? null : (
    <Box
      margin="0 10px"
      css={{
        overflow: "auto",

        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      <TabBar gap={isBiggerThanLg ? 32 : 0} justifyContent="space-between">
        {MENUS.map((item, i) => {
          const isActive = "상품안내" === item.text;
          const isReview = item.to === "/review/";
          const isPrime = item.to.includes("product");

          return (
            <Box
              position="relative"
              key={i}
              css={responsive({
                borderBottom: {
                  base: isActive ? `2px solid ${colors.gray900}` : "none",
                  lg: "none",
                },
              })}
            >
              <Link href={parseToPrimeUrl(item.to)}>
                <TabBar.Tab
                  className={`${
                    isActive ? "subtitle_16_b gray900" : "body_16_m gray500"
                  } gray500`}
                  css={responsive({
                    padding: "6px 0px",
                    margin: "6px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                    color: {
                      base: isActive ? colors.gray900 : "",
                    },
                  })}
                  onClick={() => {
                    item.eventDetails.map((trigger_and_target) => {
                      customEvent({
                        newGtm: {
                          path: "gnb",
                          trigger_and_target,
                        },
                      });
                    });
                  }}
                >
                  <HStack gap="2px" alignItems="center" justifyContent="center">
                    {/* {isPrime && (
                      <Box
                        position="absolute"
                        top="-0px"
                        right="-20px"
                        // width="12px"
                        height="14px"
                        lineHeight="12px"
                        fontSize="9px"
                        fontWeight="bold"
                        backgroundColor="red"
                        padding="2px 4px"
                        borderRadius="15px"
                        color="white"
                        zIndex="10"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        EVENT
                      </Box>
                    )} */}
                    {item.text}
                    {isPrime && (
                      <Box
                        className="white"
                        padding="1px 6px"
                        // backgroundColor={colors.danger}
                        backgroundColor={colors.orange700}
                        // color={colors.white}
                        borderRadius="20px"
                        css={{
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "18px",
                        }}
                      >
                        N
                      </Box>
                    )}
                    {isReview && reviewCount > 0 && (
                      <Box
                        className="white"
                        padding="1px 6px"
                        backgroundColor={colors.orange700}
                        borderRadius="20px"
                        css={{
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "18px",
                        }}
                      >
                        {reviewCount}
                      </Box>
                    )}
                  </HStack>
                </TabBar.Tab>
              </Link>
            </Box>
          );
        })}
      </TabBar>
    </Box>
  );
}

export function HeaderButtons({
  isHomeViewportTop,
  homePath,
}: {
  isHomeViewportTop: boolean;
  homePath: string;
}) {
  // const isLoggedIn = useRecoilValue(isLoggedInState);
  // const router = useRouter();

  return (
    <>
      {/* {isLoggedIn || (
        <div
          className="body3_m"
          css={{
            padding: "6px 6px",
            backgroundColor: isHomeViewportTop ? "transparent" : "white",
            color: isHomeViewportTop ? "white" : "black",
            border: `1px solid ${colors.gray200}`,
            borderRadius: "5px",
            marginRight: "8px",
            tansition: "all 0.1s linear",
          }}
          onClick={() => {
            customEvent({
              newGtm: {
                path: "gnb",
                trigger_and_target: "contract_check-prime",
              },
            });
            router.push(`https://prime.goifuneral.co.kr/?utm_campaign=platform`);
          }}
        >
          100원상조
        </div>
      )} */}
      {
        // isLoggedIn ? (
        //   <HeaderBtn
        //     type="BLACK"
        //     onClick={() => {
        //       router.push("/step-guide/initiation/");
        //     }}
        //     eventTrigger="step-guide"
        //   >
        //     장례준비 가이드
        //   </HeaderBtn>
        // ) :
        // <HeaderBtn
        //   type="ORANGE"
        //   onClick={() => {
        //     router.push("/funeral-prepare/1/");
        //   }}
        //   eventTrigger="srvc_rcmms-uv_funeral_prepare_1"
        // >
        //   장례가 처음이라면?
        // </HeaderBtn>

        <HeaderButton
          path="gnb"
          type="RED"
          onClick={() => {
            call("1666-9784");
            // router.push("/funeral-prepare/1/");
          }}
          eventTrigger="srvc_rcmms-uv_funeral_prepare_1"
        >
          24시간 고객센터
        </HeaderButton>
      }
    </>
  );
}

export function HeaderRegistrationButton({
  isHomeViewportTop,
  homePath,
}: {
  isHomeViewportTop: boolean;
  homePath: string;
}) {
  // const isLoggedIn = useRecoilValue(isLoggedInState);
  // const router = useRouter();

  return (
    <>
      <HeaderButton
        path="gnb"
        type="RED"
        onClick={() => {
          call("1666-9784");
          // router.push("/funeral-prepare/1/");
        }}
        eventTrigger="srvc_rcmms-uv_funeral_prepare_1"
      >
        상담원 연결하기
      </HeaderButton>
    </>
  );
}

export const PRODUCT_TAB_BAR_MENUS = [
  {
    name: "전체상품",
    url: "/product/",
  },
  {
    name: "100원상조",
    url: getPrimeUrl("/"),
  },
  {
    name: "자주묻는질문",
    url: getPrimeUrl("/faq"),
  },
  {
    name: "회사소개",
    url: getPrimeUrl("/introduce/new/"),
  },
];

function HeaderProductTabBar() {
  const router = useRouter();
  const currentMenuName = useMemo(() => {
    if (router.pathname === "/") return PRODUCT_TAB_BAR_MENUS[1].name;
    else if (router.pathname.includes("faq"))
      return PRODUCT_TAB_BAR_MENUS[2].name;
    else return "";
  }, [router]);
  const { isHide, firstOffsetCondition } = useHandleHeaderServiceTabBar({
    firstOffset: SECOND_HEADER_HEIGHT,
    secondOffsetId: "product-navigator-bar",
  });
  const { isBiggerThanLg } = useResponsive();
  return isHide ? null : (
    <HStack
      width="100%"
      className={`header`}
      justifyContent="center"
      css={{
        position: "fixed",
        top: isBiggerThanLg
          ? HEADER_HEIGHT
          : HEADER_HEIGHT + SECOND_HEADER_HEIGHT - firstOffsetCondition,
        background: "white",
        padding: "0 16px",
        overflowX: "auto",
        zIndex: 999,
        left: 0,
        right: 0,
        "&::-webkit-scrollbar": {
          display: "none",
        },
        borderTop: `1px solid ${colors.gray100}`,
        borderBottom: `1px solid ${colors.gray100}`,
      }}
    >
      <HStack width="100%" maxWidth="480px" gap="10px">
        {PRODUCT_TAB_BAR_MENUS.map(({ name, url }) => (
          <Box
            key={name}
            flex="0 0 auto"
            className={
              name === currentMenuName
                ? "subtitle_16_b gray900"
                : "body_16_m gray500"
            }
            css={{
              padding: "10px 4px",
              borderBottom:
                name === currentMenuName
                  ? `2px solid ${colors.gray900}`
                  : "none",
              whiteSpace: "nowrap",
              cursor: "pointer",
            }}
            // onClick={() => {
            //   router.push(url);
            // }}
          >
            <Link
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "product_main",
                    trigger_and_target: "tab_type-view_type",
                    text: name,
                  },
                });
              }}
              href={parseToPrimeUrl(url)}
            >
              {name}
            </Link>
          </Box>
        ))}
      </HStack>
    </HStack>
    // </Box>
  );
}
export const useHandleHeaderServiceTabBar = ({
  firstOffset = 46,
  secondOffsetId = "",
}: {
  firstOffset?: number;
  secondOffsetId?: string;
}) => {
  const [isHide, setIsHide] = useState(false);
  const [firstOffsetCondition, setFirstOffsetCondition] = useState(0);
  const lastScrollYRef = useRef(0);
  const ticking = useRef(false);

  useEffect(() => {
    const handleScroll: any = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;

          const isScrollingDown = currentScrollY > lastScrollYRef.current;
          const isScrollingUp = currentScrollY < lastScrollYRef.current;

          const top = 0;

          // iOS 바운스 스크롤을 고려한 최상단 체크
          if (currentScrollY <= 5) {
            setFirstOffsetCondition(0);
            setIsHide(false);
          } else {
            setFirstOffsetCondition(currentScrollY > 0 ? firstOffset : 0);

            const el = document.getElementById(secondOffsetId);

            if (currentScrollY < top) {
              setFirstOffsetCondition(firstOffset);
              setIsHide(false);
            } else {
              // 스크롤이 조금이라도 움직이면 바로 처리
              if (isScrollingDown) {
                setFirstOffsetCondition(firstOffset);
                if (el && el.getBoundingClientRect().top <= HEADER_HEIGHT + 8) {
                  setIsHide(true);
                } else {
                  setIsHide(firstOffset > 0 ? false : true);
                }
              } else if (isScrollingUp) {
                setFirstOffsetCondition(firstOffset > 0 ? 0 : firstOffset);
                setIsHide(false);
              }
            }
          }

          lastScrollYRef.current = currentScrollY;
          ticking.current = false;
        });

        ticking.current = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [firstOffset, secondOffsetId]);

  return { isHide, firstOffsetCondition };
};
